export interface Category {
  id: string;
  name: string;
  icon: string;
}

export const categories: Category[] = [
  { id: "electronica", name: "Electrónica", icon: "ri-smartphone-line" },
  { id: "moda", name: "Moda", icon: "ri-shirt-line" },
  { id: "hogar", name: "Hogar", icon: "ri-home-3-line" },
  { id: "vehiculos", name: "Vehículos", icon: "ri-car-line" },
  { id: "deportes", name: "Deportes", icon: "ri-basketball-line" },
  { id: "inmuebles", name: "Inmuebles", icon: "ri-building-line" },
  { id: "servicios", name: "Servicios", icon: "ri-service-line" },
  { id: "empleo", name: "Empleo", icon: "ri-briefcase-line" },
];